module.exports = __webpack_public_path__ + "img/load-sm.5f6edad1.gif";